import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import '../Auth/styles.css';

const PasswordForgetPage = () => (
  <div className="auth-page">
    <div className="auth-hero">
      {/* Decorative background elements */}
      <div className="hero-motif">
        <div className="hero-motif-gradient-1" />
        <div className="hero-motif-gradient-2" />
        <div className="hero-motif-gradient-3" />
        <span className="hero-motif-line" />
        <div className="hero-motif-orb" />
      </div>
      
      <div className="auth-hero-content">
        <span className="auth-overline">Douglas &amp; McCartney</span>
        <h1 className="auth-title headline-reveal">Reset password.</h1>
        <p className="auth-subtitle">Enter your email to receive a password reset link.</p>
      </div>
    </div>

    <div className="auth-form-panel">
      <div className="auth-form-card">
        <header className="auth-form-header">
          <span className="auth-brand-wordmark">Douglas &amp; McCartney</span>
          <h2>Forgot password?</h2>
          <p>We'll send you a link to reset your password.</p>
        </header>

        <PasswordForgetForm />

        <div style={{ borderTop: '1px solid rgba(168, 168, 168, 0.2)', paddingTop: '2rem' }}>
          <p className="auth-inline-link">
            Remember your password?{' '}
            <Link to={ROUTES.SIGN_IN} className="auth-link">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  </div>
);

const INITIAL_STATE = {
  email: '',
  error: null,
  success: false,
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email } = this.state;

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE, success: true });
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error, success } = this.state;

    const isInvalid = email === '';

    return (
      <form onSubmit={this.onSubmit} className="auth-form" noValidate>
        <div className="auth-field">
          <label htmlFor="reset-email">Email</label>
          <input
            id="reset-email"
            name="email"
            value={email}
            onChange={this.onChange}
            type="email"
            placeholder="name@example.com"
            required
          />
        </div>

        {error && <p className="auth-error">{error.message}</p>}

        {success && (
          <div style={{
            margin: 0,
            fontSize: '0.85rem',
            fontWeight: '600',
            color: '#047857',
            background: 'rgba(16, 185, 129, 0.1)',
            padding: '0.75rem 1rem',
            borderRadius: '14px',
            border: '1px solid rgba(16, 185, 129, 0.2)',
            animation: 'fade-in-up 0.6s ease-out forwards'
          }}>
            Password reset email sent! Check your inbox.
          </div>
        )}

        <button disabled={isInvalid} type="submit" className="auth-submit">
          Reset Password
        </button>

        <p className="auth-terms">
          Need help? Contact{' '}
          <Link to="#" className="auth-link auth-link--inline">
            support
          </Link>
          .
        </p>
      </form>
    );
  }
}

const PasswordForgetLink = () => (
  <p>
    <Link to={ROUTES.PASSWORD_FORGET} className="auth-link">
      Forgot password?
    </Link>
  </p>
);

export default PasswordForgetPage;

const PasswordForgetForm = withFirebase(PasswordForgetFormBase);

export { PasswordForgetForm, PasswordForgetLink };
